/* ============================================================
   Flow Wake-Up Quiz — Intelligems experiment assignment
   Exposes: window.FlowQuizExperiments
   ============================================================ */

(function () {
  if (window.FlowQuizExperiments) return;

  var LANDING_COPY_TEST = {
    id: 'quiz_landing_copy',
    name: 'Quiz first-step copy - Current vs Right For You',
    experimentId: '15a70106-e68a-41ec-8f52-c445cc4ad1d5',
    timeoutMs: 1200,
    pollMs: 60,
    previewParam: 'quiz_landing_variant',
    previewStorageKey: 'flow-quiz-landing-variant-preview',
    variants: {
      control: {
        key: 'control',
        name: 'Current Intro',
        variationId: '',
        isControl: true
      },
      right_for_you: {
        key: 'right_for_you',
        name: 'Right For You',
        variationId: '',
        isControl: false
      }
    }
  };

  var cachedLandingAssignment = null;

  function normalizeVariantKey(value) {
    var normalized = String(value || '')
      .toLowerCase()
      .replace(/&/g, ' and ')
      .replace(/[^a-z0-9]+/g, '_')
      .replace(/^_+|_+$/g, '');

    if (
      normalized === 'right_for_you' ||
      normalized === 'treatment' ||
      normalized === 'variant_b' ||
      normalized === 'new' ||
      normalized === 'new_copy'
    ) {
      return 'right_for_you';
    }

    if (
      normalized === 'control' ||
      normalized === 'current' ||
      normalized === 'current_intro' ||
      normalized === 'baseline'
    ) {
      return 'control';
    }

    return null;
  }

  function readPreviewVariant() {
    var params;
    var raw;
    var key;

    try {
      params = new URLSearchParams(window.location.search || '');
      raw = params.get(LANDING_COPY_TEST.previewParam) || params.get('qlv');
    } catch (e) {
      raw = null;
    }

    if (raw === 'clear') {
      try { localStorage.removeItem(LANDING_COPY_TEST.previewStorageKey); } catch (e1) {}
      return null;
    }

    key = normalizeVariantKey(raw);
    if (key) {
      try { localStorage.setItem(LANDING_COPY_TEST.previewStorageKey, key); } catch (e2) {}
      return key;
    }

    try {
      return normalizeVariantKey(localStorage.getItem(LANDING_COPY_TEST.previewStorageKey));
    } catch (e3) {
      return null;
    }
  }

  function findVariantByAssignment(rawGroup) {
    var variants = LANDING_COPY_TEST.variants;
    var rawId = null;
    var rawName = null;
    var key;

    if (!rawGroup) return null;

    if (typeof rawGroup === 'string') {
      rawId = rawGroup;
      rawName = rawGroup;
    } else if (typeof rawGroup === 'object') {
      rawId = rawGroup.id || rawGroup.variationId || rawGroup.variation_id || rawGroup.value || null;
      rawName = rawGroup.name || rawGroup.variationName || rawGroup.variation_name || rawGroup.label || null;
    }

    key = normalizeVariantKey(rawName) || normalizeVariantKey(rawId);
    if (key && variants[key]) return variants[key];

    if (rawId && variants.right_for_you.variationId && rawId === variants.right_for_you.variationId) {
      return variants.right_for_you;
    }
    if (rawId && variants.control.variationId && rawId === variants.control.variationId) {
      return variants.control;
    }

    return null;
  }

  function getIntelligemsGroup() {
    var igUser = window.igData && window.igData.user;

    if (
      !LANDING_COPY_TEST.experimentId ||
      !igUser ||
      typeof igUser.getTestGroup !== 'function'
    ) {
      return null;
    }

    try {
      return igUser.getTestGroup(LANDING_COPY_TEST.experimentId);
    } catch (e) {
      return null;
    }
  }

  function buildAssignment(variant, source, rawGroup) {
    return {
      testId: LANDING_COPY_TEST.id,
      testName: LANDING_COPY_TEST.name,
      experimentId: LANDING_COPY_TEST.experimentId || null,
      experimentName: LANDING_COPY_TEST.name,
      variantKey: variant.key,
      variationId: variant.variationId || null,
      variationName: variant.name,
      isControl: Boolean(variant.isControl),
      source: source,
      rawGroup: rawGroup || null
    };
  }

  function getControlAssignment(source, rawGroup) {
    return buildAssignment(LANDING_COPY_TEST.variants.control, source || 'fallback', rawGroup);
  }

  function analyticsProps(assignment) {
    var value = assignment || getControlAssignment('fallback');
    var resolved = value.source === 'intelligems' || value.source === 'preview';

    return {
      quiz_landing_test_id: value.testId,
      quiz_landing_test_name: value.testName,
      quiz_landing_variant: resolved ? value.variantKey : 'unassigned',
      quiz_landing_variation_name: value.variationName,
      quiz_landing_assignment_source: value.source,
      intelligems_experiment_id: value.experimentId,
      intelligems_experiment_name: value.experimentName,
      intelligems_variation_id: value.variationId,
      intelligems_variation_name: value.variationName,
      intelligems_is_control: value.isControl
    };
  }

  function resolveLandingAssignment() {
    var previewKey = readPreviewVariant();
    var rawGroup;
    var variant;

    if (cachedLandingAssignment) return Promise.resolve(cachedLandingAssignment);

    if (previewKey && LANDING_COPY_TEST.variants[previewKey]) {
      cachedLandingAssignment = buildAssignment(LANDING_COPY_TEST.variants[previewKey], 'preview', null);
      return Promise.resolve(cachedLandingAssignment);
    }

    rawGroup = getIntelligemsGroup();
    variant = findVariantByAssignment(rawGroup);
    if (variant) {
      cachedLandingAssignment = buildAssignment(variant, 'intelligems', rawGroup);
      return Promise.resolve(cachedLandingAssignment);
    }

    if (!LANDING_COPY_TEST.experimentId) {
      cachedLandingAssignment = getControlAssignment('unconfigured', rawGroup);
      return Promise.resolve(cachedLandingAssignment);
    }

    return new Promise(function (resolve) {
      var startedAt = Date.now();
      var timer = window.setInterval(function () {
        rawGroup = getIntelligemsGroup();
        variant = findVariantByAssignment(rawGroup);

        if (variant) {
          window.clearInterval(timer);
          cachedLandingAssignment = buildAssignment(variant, 'intelligems', rawGroup);
          resolve(cachedLandingAssignment);
          return;
        }

        if (Date.now() - startedAt >= LANDING_COPY_TEST.timeoutMs) {
          window.clearInterval(timer);
          cachedLandingAssignment = getControlAssignment('fallback', rawGroup);
          resolve(cachedLandingAssignment);
        }
      }, LANDING_COPY_TEST.pollMs);
    });
  }

  window.FlowQuizExperiments = {
    landingCopyTest: LANDING_COPY_TEST,
    resolveLandingAssignment: resolveLandingAssignment,
    getLandingAssignment: function () {
      return cachedLandingAssignment || getControlAssignment('pending');
    },
    getLandingAnalyticsProps: function () {
      return analyticsProps(cachedLandingAssignment);
    },
    analyticsProps: analyticsProps
  };
})();
